module.exports = __webpack_public_path__ + "static/2-e0301685e4e304b2c1c0e2b57bf0becd.jpg";